import { Platform } from 'react-native';

let LoginScreen;

if (Platform.OS === 'web') {
  LoginScreen = require('./Login.web').default;
} else {
  LoginScreen = require('./Login').default;
}

export default LoginScreen;
